import {memo, ReactNode, useMemo} from "react";
import {Camera} from "../../utility/camera";

/** The viewport contains all the other elements of the diagram and applies the camera transform. */
export const Viewport = memo(({camera, children}: {camera: Camera; children?: ReactNode}) => {
  const style = useMemo(
    () =>
      ({
        pointerEvents: "none",
        transform: `translate(${camera.size.x / 2}px, ${camera.size.y / 2}px) scale(${
          camera.zoomFactor
        }) translate(${-camera.position.x}px, ${-camera.position.y}px)`,
        transformOrigin: "0 0" as const,
      }) as const,
    [camera.size.x, camera.size.y, camera.zoomFactor, camera.position.x, camera.position.y],
  );

  return <div style={style}>{children}</div>;
});
